import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import coverImage from '../../../images/articles/computervision-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const ComputerVision = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='Computer Vision for Business: Practical Uses'
        description={translations.BlogComputerVision1}
        type='article'
        image={coverImage}
        jsonLd={[
          articleJsonLd({
            headline: translations.BlogComputerVision,
            description: translations.BlogComputerVision1,
            image: coverImage,
            path: '/articles/computerVision',
            datePublished: '2026-06-20',
            author: translations.BlogComputerVision12,
          }),
          articleBreadcrumbs(translations.BlogComputerVision, '/articles/computerVision'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogComputerVision}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogComputerVision11}</p>
              <p>•</p>
              <p>{translations.BlogComputerVision12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogComputerVision13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={coverImage} alt='Close-up of a camera lens' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='computerVision' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogComputerVision1}</p>
              <p>{translations.BlogComputerVision2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogComputerVision3}</h2>
              <p>{translations.BlogComputerVision4}</p>
              <p>{translations.BlogComputerVision5}</p>
              <p>{translations.BlogComputerVision6}</p>

              <h2 className='article-secondaty-title'>{translations.BlogComputerVision7}</h2>
              <p>{translations.BlogComputerVision8}</p>
              <p>{translations.BlogComputerVision9}</p>
              <p>{translations.BlogComputerVision10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/genAi' title={translations.BlogGenAi} />
        </div>
      </div>
    </Layout>
  )
}

export default ComputerVision
